import src from "IMAGE";
export default { src, width: 1435, height: 139, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAI0lEQVR42mOQlJR8Jy0t/R5ES0hIgNgfZGRkPkhJSb0D0u8BmSUJ7X2pZCIAAAAASUVORK5CYII="};
